const AUTO_COLLAPSE_ROUTES = ['/admin-geral/chat-atendimento', '/admin-geral/secretaria/triagem'];

const AUTO_COLLAPSE_PATTERNS = [/^\/admin-geral\/secretaria\/processos\/[^/]+/];

export function shouldAutoCollapseSidebar(path: string): boolean {
  return (
    AUTO_COLLAPSE_ROUTES.some((route) => path.startsWith(route)) ||
    AUTO_COLLAPSE_PATTERNS.some((pattern) => pattern.test(path))
  );
}
